
// Import blog post data
import { etfMythosPost } from './etf-mythos';
import { kiSuchmaschinen2025Post } from './ki-suchmaschinen-2025';
import { betriebssystemPost } from './betriebssystem-v5-2';
import { weisheitUndExpertisePost } from './weisheit-und-expertise';
import { MusikUndEmotionen as musikUndEmotionenPost } from './musik-und-emotionen';
import { KiGestuetzteWebentwicklung as kiGestuetzteWebentwicklungPost } from './ki-gestuetzte-webentwicklung';
import { FinanzcoachingVsFinanzberatung as finanzcoachingVsFinanzberatungPost } from './finanzcoaching-vs-finanzberatung';
import { GesundesVerhaeltnisZuGeld as gesundesVerhaeltnisZuGeldPost } from './gesundes-verhaeltnis-zu-geld';
import { KryptoSteuerKlarheit as kryptoSteuerKlarheitPost } from './krypto-steuer-klarheit';
import { NeuroplastizitaetEpigenetik as neuroplastizitaetEpigenetikPost } from './neuroplastizitaet-epigenetik';
import { SocialMediaEmotionen as socialMediaEmotionenPost } from './social-media-emotionen';
import { CoachingAlsLebensphilosophie as coachingAlsLebensphilosophiePost } from './coaching-als-lebensphilosophie';
import { KiFianzielleEmotionaleUnabhaengigkeit as kiFinanzielleEmotionaleUnabhaengigkeitPost } from './ki-finanzielle-emotionale-unabhaengigkeit';
import { outdoorCoachingPost } from './outdoor-coaching';
import { kostolanyFinanzweisheitPost } from './kostolany-finanzweisheit';
import { digitalerHumanismusKommunikationPost } from './digitaler-humanismus-kommunikation/index';
import { mythosNischePost } from './mythos-nische';
import { mythosPositivesDenkenPost } from './mythos-positives-denken';
import { FrommHabenSeinPost } from './fromm-haben-sein';
import { koerperFuehrungPost } from './koerper-fuehrung';
import { fuehrung2026HaltungEmpathiePost } from './fuehrung-2026-haltung-empathie';
import { hochsensibleFuehrungPost } from './hochsensible-fuehrung';
import { souveraenitaetKomplexitaetPost } from './souveraenitaet-komplexitaet';
import { BlogPost } from '@/types/blog';

// Export all blog posts in an array
export const blogPosts: BlogPost[] = [
  souveraenitaetKomplexitaetPost,
  finanzcoachingVsFinanzberatungPost,
  hochsensibleFuehrungPost,
  fuehrung2026HaltungEmpathiePost,
  koerperFuehrungPost,
  etfMythosPost,
  kiSuchmaschinen2025Post,
  FrommHabenSeinPost,
  mythosPositivesDenkenPost,
  betriebssystemPost,
  mythosNischePost,
  digitalerHumanismusKommunikationPost,
  kostolanyFinanzweisheitPost,
  weisheitUndExpertisePost,
  musikUndEmotionenPost,
  kiGestuetzteWebentwicklungPost,
  gesundesVerhaeltnisZuGeldPost,
  kryptoSteuerKlarheitPost,
  neuroplastizitaetEpigenetikPost,
  socialMediaEmotionenPost,
  coachingAlsLebensphilosophiePost,
  kiFinanzielleEmotionaleUnabhaengigkeitPost,
  outdoorCoachingPost
];

if (typeof window !== 'undefined') {
  console.info('[blogPosts] total:', blogPosts.length);
}

// Export individual blog posts for direct access
export {
  souveraenitaetKomplexitaetPost,
  hochsensibleFuehrungPost,
  fuehrung2026HaltungEmpathiePost,
  koerperFuehrungPost,
  etfMythosPost,
  kiSuchmaschinen2025Post,
  FrommHabenSeinPost,
  mythosPositivesDenkenPost,
  betriebssystemPost,
  mythosNischePost,
  digitalerHumanismusKommunikationPost,
  kostolanyFinanzweisheitPost,
  weisheitUndExpertisePost,
  musikUndEmotionenPost,
  kiGestuetzteWebentwicklungPost,
  finanzcoachingVsFinanzberatungPost,
  gesundesVerhaeltnisZuGeldPost,
  kryptoSteuerKlarheitPost,
  neuroplastizitaetEpigenetikPost,
  socialMediaEmotionenPost,
  coachingAlsLebensphilosophiePost,
  kiFinanzielleEmotionaleUnabhaengigkeitPost,
  outdoorCoachingPost
};
